<template>
  <InputPicker
    button-label="Insert variable"
    button-icon="calculator"
    :textarea="textarea"
    :items="variables"
    :trigger="trigger"
    :triggerStart="convertToRegexGroup(['{{!@', '{{@', '{'])"
    @input="$emit('input', $event)"
    @cancelTrigger="(refocus) => $emit('cancelTrigger', refocus)"
  >
    <template #default="{items, select, insertSelected}">
      <div v-for="(variableGroup, category) in items" :key="category">
        <h5 class="mt-3">
          {{ category }}
        </h5>
        <div class="variables">
          <button
            v-for="(variable, variableName) in variableGroup"
            :key="variable"
            class="btn btn-light btn-sm mr-2 mb-2"
            type="button"
            @click="selectAndInsert(variable, select, insertSelected)"
          >
            {{ variableName }}
          </button>
        </div>
      </div>
    </template>
  </InputPicker>
</template>

<script>
import InputPicker from "@/FormWidgets/WidgetInputArea/components/InputPicker.vue";
import { convertToRegexGroup } from "@/utils/text";

export default {
  name: "VariablePicker" ,
  components: {InputPicker},
  // Vue 3:
  // emits: ['input', 'cancelTrigger'], // Even without a typed trigger, @cancelTrigger refocuses the textarea
  props: {
    textarea: Function,
    variables: Object,
    trigger: {
      type: [KeyboardEvent, Boolean],
      default: false,
    },
  },
  methods: {
    convertToRegexGroup,
    selectAndInsert: function(variable, select, insertSelected) {
      select(variable);
      insertSelected();
    }
  }
}
</script>
